import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { upsertSetting } from "../../features/settings/settingsSlice";

export const useAssistantName = ({
  assistant,
  setting,
  assistantId,
  isInstallPage,
  setSetting,
}) => {
  const dispatch = useDispatch();

  const [displayName, setDisplayName] = useState("");
  const [editedName, setEditedName] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const name = isInstallPage
      ? assistant?.name || ""
      : setting?.assistantName || assistant?.name || "";

    setDisplayName(name);
  }, [assistant?.name, setting?.assistantName, isInstallPage]);

  const startEdit = () => {
    setEditedName(displayName);
    setIsEditing(true);
  };

  const saveName = async () => {
    if (!editedName.trim()) {
      toast.error("Assistant name cannot be empty!");
      return;
    }

    try {
      const payload = {
        uuid: assistantId,
        data: {
          uuid: setting.uuid,
          assistantName: editedName,
        },
      };

      await dispatch(upsertSetting(payload));

      setDisplayName(editedName);
      setIsEditing(false);

      toast.success("Assistant name updated successfully.");
    } catch {
      toast.error("Failed to update assistant name");
    }
  };
  return {
    displayName,
    editedName,
    setEditedName,
    isEditing,
    setIsEditing,
    saveName,
    startEdit,
  };
};
